import { icons } from '@chillibean/component-library/legacy';
import { PropTypes } from 'prop-types';

import IconButton from '../../../../primitives/form/IconButton/IconButton';

function AssetFormsIconButton(props) {
  const { navigateAway } = props;

  return (
    <IconButton
      icon={icons.leftArrow}
      colour="#ffffff"
      size={20}
      viewBox="0 0 20 20"
      handleClick={navigateAway}
      testID="asset-forms-back-button"
    />
  );
}

AssetFormsIconButton.propTypes = {
  navigateAway: PropTypes.func.isRequired,
};

export default AssetFormsIconButton;
